const LOCALHOST_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);

export const API_HEALTH_RETRY_DEBOUNCE_MS = 10_000;

export const isBrowserOffline = (
  navigatorRef: Pick<Navigator, "onLine"> | undefined,
): boolean => (navigatorRef ? !navigatorRef.onLine : false);

export const isLocalhostHostname = (hostname: string | undefined): boolean => {
  if (!hostname) {
    return false;
  }

  return LOCALHOST_HOSTNAMES.has(hostname.toLowerCase());
};

export const shouldTriggerHealthRetry = (
  now: number,
  lastNetworkFailureAt: number,
  debounceMs = API_HEALTH_RETRY_DEBOUNCE_MS,
): boolean => now - lastNetworkFailureAt >= debounceMs;
